import React from 'react';
import { createPortal } from 'react-dom';
import loadericon from '../assets/icon/spinner.gif';

/**
 *
 * @param string className: SCSS class for background color, intended to allow different background colors.
 * @param string id: DOM id of the overlay. Defaults to the global one that the axios interceptors
 *        toggle by hand; pass a different id when a screen mounts its own loader, otherwise the
 *        duplicated id would hijack every document.getElementById('overlay') in the app.
 * @param boolean portal: renders the overlay into document.body. Needed whenever the loader is
 *        mounted under an ancestor with a transform - the tabs rendered by SwipeableViews, for
 *        instance - because such an ancestor becomes the containing block of its position: fixed
 *        descendants, so the overlay would cover only that box instead of the page.
 */
const FullPageLoader = ({className= "background-general-950-opacity05", id = 'overlay', portal = false}) => {
    const loader = (
        <div className={`loader_container ${className}`} id={id}>
            <div className='loader_div'>
                <img src={loadericon} alt='' width='80px' height='80px' />
            </div>
        </div>
    );

    return portal ? createPortal(loader, document.body) : loader;
};

export default FullPageLoader;
